import { useStaticQuery, graphql } from 'gatsby';
import { Query } from '../../../../__generated__/gatsby-types';

const outageFAQAccordianDetailsQuery = graphql`
  {
    allContentfulModuleAccordion(
      filter: { contentful_id: { in: "3TpKQ7mEl3CK0BZiBNtgBt" } }
    ) {
      nodes {
        node_locale
        accordionHeader
        accordionItems {
          entryName
          tabTitle
          tabBody {
            raw
          }
        }
      }
    }
  }
`;

export default () => {
  const { allContentfulModuleAccordion } = useStaticQuery<Query>(
    outageFAQAccordianDetailsQuery,
  );

  return {
    allContentfulModuleAccordion,
  };
};
